import { AlertTriangle, CreditCard, FileText, ShieldCheck } from "lucide-react";
import LegalPage from "../Components/LegalPage";

const Section = ({ title, Icon, children }) => (
  <section className="mb-8">
    <h2 className="flex items-center gap-2 font-display text-xl font-bold text-ink-800 sm:text-2xl">
      {Icon && <Icon size={20} className="text-brand-600" />}
      {title}
    </h2>
    <div className="mt-4 space-y-4 text-[14.5px] leading-7 text-ink-600">
      {children}
    </div>
  </section>
);

const Card = ({ title, children, tone }) => (
  <div className={`rounded-2xl border p-5 ${
    tone === "warning"
      ? "border-rose-200 bg-rose-50"
      : tone === "success"
      ? "border-emerald-200 bg-emerald-50"
      : "border-sand-200 bg-sand-50"
  }`}>
    {title && (
      <h3 className={`mb-2 font-semibold ${
        tone === "warning" ? "text-rose-700" : tone === "success" ? "text-emerald-700" : "text-brand-700"
      }`}>
        {title}
      </h3>
    )}
    {children}
  </div>
);

const RefundPolicy = () => (
  <LegalPage
    title="Refund Policy"
    subtitle="Please read this policy carefully before purchasing a Premium membership."
    Icon={CreditCard}
  >
    <Section title="1. No Refund After Payment" Icon={AlertTriangle}>
      <Card tone="warning" title="All successful payments are non-refundable">
        <p className="text-[13.5px] leading-6 text-rose-800">
          Once a Premium membership payment is successfully completed on Karanki Matrimony, the payment is final and no refund will be issued.
        </p>
        <p className="mt-3 text-[13.5px] leading-6 text-rose-800">
          This applies to all Premium plans, offers, discounts, coupons, and membership purchases.
        </p>
      </Card>
    </Section>

    <Section title="2. Situations Not Eligible for Refund" Icon={FileText}>
      <Card>
        <ul className="list-disc space-y-1 pl-5">
          <li>Change of mind after purchase</li>
          <li>Not using Premium features during the membership period</li>
          <li>Dissatisfaction with profile matches or search results</li>
          <li>Accidental purchase after confirming payment</li>
          <li>Account suspension, blocking, or termination due to policy violation</li>
          <li>Failure to read the pricing, plan duration, or terms before payment</li>
        </ul>
      </Card>
    </Section>

    <Section title="3. Duplicate or Technical Payment Issues" Icon={ShieldCheck}>
      <Card tone="success" title="We will investigate genuine payment errors">
        <p>
          If you believe you were charged twice for the same transaction because of a technical error, contact us with your payment ID, order ID, phone number, and transaction date.
        </p>
        <p className="mt-2">
          Verified duplicate charges may be reviewed and resolved at our discretion after checking Razorpay and our payment records.
        </p>
      </Card>
    </Section>

    <Section title="4. Contact">
      <p>
        For payment questions, please contact us through the Contact Us page or email karankimatrimony2020@gmail.com with your transaction details.
      </p>
    </Section>
  </LegalPage>
);

export default RefundPolicy;
